import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    Tooltip,
} from 'chart.js';
import { formatNumber } from './formatNumber';

// Ensure the related components are registered so their default keys exist
// regardless of import order across pages.
ChartJS.register(LinearScale, CategoryScale, Tooltip);

// Y-axis ticks: format integers with thousand separator.
// Non-integers fall through unchanged so percentages / decimals are not mangled.
ChartJS.defaults.scales = ChartJS.defaults.scales || {};
ChartJS.defaults.scales.linear = ChartJS.defaults.scales.linear || {};
ChartJS.defaults.scales.linear.ticks = ChartJS.defaults.scales.linear.ticks || {};
ChartJS.defaults.scales.linear.ticks.callback = function (value) {
    if (typeof value === 'number' && Number.isFinite(value) && Number.isInteger(value)) {
        return formatNumber(value);
    }
    return value;
};

// Tooltip body: format numeric values with thousand separators.
ChartJS.defaults.plugins = ChartJS.defaults.plugins || {};
ChartJS.defaults.plugins.tooltip = ChartJS.defaults.plugins.tooltip || {};
ChartJS.defaults.plugins.tooltip.callbacks = ChartJS.defaults.plugins.tooltip.callbacks || {};
ChartJS.defaults.plugins.tooltip.callbacks.label = function (context) {
    const label = context.dataset?.label ? context.dataset.label + ': ' : '';
    // The value lives on the axis opposite to indexAxis: horizontal bars
    // (indexAxis: 'y') keep the value on x, vertical charts keep it on y.
    // Reading .y blindly returns the category index on horizontal charts.
    const parsed = context.parsed;
    let raw;
    if (parsed !== null && typeof parsed === 'object') {
        const valueAxis = context.chart?.options?.indexAxis === 'y' ? 'x' : 'y';
        raw = parsed[valueAxis] ?? parsed.y ?? parsed.x;
    } else {
        raw = parsed;
    }
    if (typeof raw === 'number' && Number.isFinite(raw)) {
        return label + (Number.isInteger(raw) ? formatNumber(raw) : raw);
    }
    return label + (raw ?? '');
};
